// @flow
export const CAPTURE_ONLINE = 1;
export const CAPTURE_KIOSK = 13;
export const GATEWAY_TYPE_STRIPE = 14;
export const GATEWAY_TYPE_SQUARE = 33;

type Payment = {+id: number, +attributes: Object}

type SetTOSAction = {+type: "SET_TOS", +accepted: boolean};
type AddPaymentAction = {+type: "ADD_PAYMENT", +payment: Payment};

type State = {
    +tosAccepted: boolean,
    +payments: Array<Payment>,
    method: number,
    terminalId: number,
    terminals: Object,
    stripeTerminal: Object,
    connectedTerminal: Object,
    isReaderConnected: boolen,
}

export type Action = SetTOSAction | AddPaymentAction;

let initialState = {
    tosAccepted: false,
    payments: [],
    method : CAPTURE_ONLINE,
    terminalId : '',
    terminals: {},
    stripeTerminal: null,
    connectedTerminal: null,
    isReaderConnected: false,
    gatewayType: null,
    gatewayKey: null,
};

export function payment(state: State = initialState, action:Action): State {
    if(action.type === "SET_TOS") {
        let newState = {...state};
        newState.tosAccepted = action.accepted;
        return newState;
    } else if(action.type === "ADD_PAYMENT") {
        let newState = {...state};
        newState.payments.push({id: action.payment.id, ...action.payment.attributes});
        return newState;
    } else if(action.type === "SET_CHECKOUT_CONFIG") {
        let newState = {...state};
        let config = action.config;

        if(config.captureMethod) {
            newState.method = config.captureMethod;
        }

        return newState;
    } else if(action.type === "SET_TERMINAL_ID") {
        let newState = {...state};
        newState.terminalId = action.terminalId;

        return newState;
    } else if(action.type === "SET_TERMINALS") {
        let newState = {...state};
        newState.terminals = action.terminals;

        return newState;
    } else if(action.type === "SET_STRIPE_TERMINAL") {
        let newState = {...state};
        newState.stripeTerminal = action.stripeTerminal;

        return newState;
    } else if(action.type === "SET_CONNECTED_TERMINAL") {
        let newState = {...state};
        newState.connectedTerminal = action.connectedTerminal;

        return newState;
    } else if(action.type === "SET_IS_READER_CONNECTED") {
        let newState = {...state};
        newState.isReaderConnected = action.isReaderConnected;

        return newState;
    } else if (action.type === "FETCH_EVENT") {
        let newState = {...state};
        let gatewaySettings      = action.data.gatewaySettings;
        newState.gatewayType     = gatewaySettings ? gatewaySettings.type    : null;
        newState.gatewayKey      = gatewaySettings ? gatewaySettings.key     : null;
        newState.gatewayLocation = gatewaySettings ? gatewaySettings.location: null;
        newState.gatewayCountry  = gatewaySettings ? gatewaySettings.country : null;
        newState.gatewayLocale   = gatewaySettings ? gatewaySettings.locale  : null;
        newState.jsUrl           = gatewaySettings ? gatewaySettings.jsUrl   : null;
        newState.wallets         = gatewaySettings ? gatewaySettings.wallets : null;
        return newState;
    } else {
        return state;
    }
}
